import DxSelectBox, { SelectBoxRef } from 'devextreme-react/select-box';
import React from 'react';

export const SelectBox: React.FC<any> = props => {
	const selectBoxRef = React.useRef<SelectBoxRef>();

	const onValueChanged = e => {
		if (e.previousValue !== e.value) {
			props.data.setValue(e.value);
			selectBoxRef.current.instance().option('value', e.value);
		}
	};

	const { items } = props.data.column.editorOptions;

	return (
		<DxSelectBox
			ref={selectBoxRef}
			defaultValue={props.data.value}
			onValueChanged={onValueChanged}
			items={items}
			displayExpr={'text'}
			valueExpr={'value'}
			searchEnabled
			searchExpr={'text'}
		/>
	);
};

export { DxSelectBox };
